module.exports = "<section>\n  <div class=\"tbc\">\n    <h2>Components TBC</h2>\n  </div>\n</section>\n"